import React, { useEffect, useState } from "react";
import {
  TableColumn,
} from "../../../components/CommnTable/CustomDataTable";
import { FundViewExpense } from "../../../types/types";
import { Button, Chip } from "@mui/material";
import { blue } from '@mui/material/colors';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {useFundContext} from "../../../Context/FundManagementContext";
import { useLoader } from "../../../Loader/LoaderContext";
import { useGet } from "../../../services/hooks/useGet";
import { GetUrl } from "../../../api/endpointConfig";
import {getStatusChipColor} from "../../../utils/common"


const useFundViewExpense = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const {fundDetail} = useFundContext()
  const { id } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const [offsetValue, setOffsetValue] = useState<number>(0);
  const [limitValue, setLimitValue] = useState<number>(10);
  const [queryParams, setQueryParams] = useState<any>({})
  const userData: any = JSON.parse(localStorage.getItem("userData") || "{}")
  const pagination: Record<string, string | number| null> = {
    offset: offsetValue,
    limit: limitValue,
  };
  
  const { data=[], isLoading, isError } = useGet<any>(
    `${GetUrl.getExpenseSummary}/${id}`, { params: {...pagination,...queryParams} }
  );

  useEffect(() => {
    const prefix = searchParams.get('prefix');
    const text = searchParams.get('text');
    setQueryParams((prev: any) => {
      const updated = { ...prev };

      if (text && prefix) {
        updated[prefix] = text;
      } else {
        setQueryParams({})
      }
      return updated;
    });
  }, [searchParams])

  useEffect(() => {
    if(isLoading && !isError) {
      showLoader()
    } else if(isError){ hideLoader()}
      else {hideLoader()}
  },[isLoading, isError])

  const columns: TableColumn<FundViewExpense>[] = [
    { field: "id", header: "Id", sortable: true, width: "2rem", filterable: true },
    { field: "purpose", header: "Purpose", sortable: true, width: "12rem", filterable: true },
    { field: "fund_date", header: "Date", sortable: true, width: "8rem", filterable: true },
    { field: "amount", header: "Amount", sortable: true, width: "4rem" },
    { field: "status", header: "Status", sortable: true, width: "4rem", filterable: true, customBody: (row: any) => (
        <Chip
          label={row.status}
           color={getStatusChipColor(row.status)}
          size="small"
          variant="filled"
          style={{ fontWeight: 600, textTransform: "capitalize" }}
        />
      ), },
    { field: "action", header: "Action", width: "4rem",  customBody: (row) => (
        <Button variant="contained" sx={{ bgcolor: blue[700],width: "70%" }} onClick={() =>
          navigate(`/fund-viewexpensedetail/view/${row.id}`)
        }>View</Button>
      ) }
  ];
  
  const HandlePagination = (e: any) => {
    setLimitValue(e.rows)
    setOffsetValue(e.page+1)
  }

  const handleAddClick = () => {
    navigate(`/fund-viewexpensedetail/${id}/add`)
  }

  return { columns, fundDetail,userData, data, HandlePagination,limitValue,handleAddClick }
}

export default useFundViewExpense